import { Component, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: 'cs-view-notification-modal',
    templateUrl: './view-notification.component.html',
    styleUrls: ['./view-notification.component.scss']
})
export class ViewNotificationModalComponent {
    constructor(private activeModal: NgbActiveModal) {

    }
    @Input() public notification;

    cancel() {
        this.activeModal.dismiss();
    }
}
